import { ClientApi } from '../../../api';
import { AppError } from '../../../api/utils/ErrorHandler';
import { PatchTermDto } from '../../../commonTypes/client.types';
import { useContainer } from '../../useContainer';

interface ExecPatchOptions {
    onSuccess?: () => void;
    onError?: (error: AppError | string) => void;
}

const useHttpPatchPaymentTerm = () => {
    const clientApi: ClientApi = useContainer(ClientApi);

    const execPatch = (id: string, body: PatchTermDto, options?: ExecPatchOptions) => {
        const { exec, abort } = clientApi.patchTerm({
            params: { id },
            body,
            onSuccess: () => {
                options?.onSuccess?.();
            },
            onError: error => {
                options?.onError?.(error);
            },
        });

        exec();
        return abort;
    };

    return { execPatch };
};

export default useHttpPatchPaymentTerm;
